var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.152 219.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.652 0H7.5A7.5 7.5 0 000 7.5v204.152a7.5 7.5 0 007.5 7.5h204.152c4.143 0 7.5-3.357 7.5-7.5V7.5a7.5 7.5 0 00-7.5-7.5zm-7.5 204.152H15V15h189.152v189.152z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.235 165.917a7.477 7.477 0 005.303 2.196 7.477 7.477 0 005.303-2.196l45.735-45.733 45.733 45.733a7.48 7.48 0 005.304 2.196 7.5 7.5 0 005.304-12.803l-45.732-45.733 45.734-45.733a7.5 7.5 0 00-10.607-10.607L109.578 98.97 63.842 53.233A7.501 7.501 0 0053.236 63.84l45.734 45.735-45.735 45.735a7.5 7.5 0 000 10.607z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/close-square.cfc405585692add45bb023e7f66ec7b9.svg";
export { ForwardRef as ReactComponent };